import React, { useEffect } from 'react';
import i18n from 'i18n-js';
import Layout from 'components/Layout';
import Feature from 'components/Feature';
import OrgAbility from 'components/OrgAbility';
import useStyles from './OrganizationDetails.styled';
import { useDispatch, useSelector } from 'react-redux';
import { PaymentMethodsStripe } from 'components/PaymentMethods';
import { OrganizationsActions } from 'state/modules/organizations';
import { Box, Grid, Container, Typography } from '@material-ui/core';
import { OrganizationDetails as OrganizationDetailsWidget } from 'components/Organization';

const OrganizationDetails = () => {
  const classes = useStyles();
  const user = useSelector((state) => state.auth.user);
  const { organization } = useSelector((state) => state.organizations);
  const sharingType = useSelector(
    (state) => state.config?.settings?.core?.partnership?.sharing_type
  );
  const id = user?.organization?.id;
  const account_id = organization.account_id;
  const dispatch = useDispatch();

  useEffect(() => {
    if (id && organization.id !== id) {
      dispatch(OrganizationsActions.fetchOrganizationById(id));
    }
  }, [id, organization, dispatch]);

  return (
    <Layout title="Organization">
      <Container className={classes.container}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container direction="row" justifyContent="space-between" spacing={2}>
              <Grid item>
                <Typography variant="h6" gutterBottom>
                  <Box fontWeight="fontWeightBold" fontSize={24} mb={1}>
                    {i18n.t('common.organization_settings')}
                  </Box>
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Grid container spacing={4}>
                  <Grid item xs={12}>
                    <OrganizationDetailsWidget organization={organization} editable />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Grid container spacing={4}>
                  {(sharingType === 'FAAS' || sharingType === 'FFB') && (
                    <Feature name="partnership" is="billing">
                      <>
                        <OrgAbility subject={['msServiceOrg']}>
                          <Grid item xs={12}>
                            <PaymentMethodsStripe
                              modelId={id}
                              accountId={account_id}
                            />
                          </Grid>
                        </OrgAbility>
                        {/* <OrgAbility subject={['msOwnerOrg']}>
                          <Grid item xs={12}>
                            <PaymentBrokersWidget
                              account={account}
                              loading={loading}
                              organization={organization}
                              accountDetails={accountDetails}
                              fetchingAccount={fetchingAccount}
                            />
                          </Grid>
                        </OrgAbility> */}
                      </>
                    </Feature>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export { OrganizationDetails };
